<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible"   style="width:400px;margin:auto;" @close="close" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="90px"  v-loading="loading" :element-loading-text="elementLoadingText">
        <el-row>
          <el-col :span="24">
            <div class="el-form-item is-required">
              <label for="mobile" class="el-form-item__label" style="width: 100px;">回寄物流：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.logistics" autocomplete="off" class="el-input__inner">   
                </div>
              </div>
            </div>
            <div class="el-form-item is-required">
              <label for="mobile" class="el-form-item__label" style="width: 100px;">回寄单号：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.logisticsNo" autocomplete="off" class="el-input__inner">   
                </div>
              </div>
            </div>
            <div class="el-form-item">           
              <label for="mobile" class="el-form-item__label" style="width: 100px;">寄回地址：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input" style="color:red;">
                  {{returnAddress.name}}  {{returnAddress.mobile}}  {{returnAddress.province}}  {{returnAddress.city}}  {{returnAddress.area}} {{returnAddress.address}} 
                </div>
              </div>
            </div>
          </el-col>   
        </el-row>   
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="closeBtn"  @click="close">取 消</el-button>
      <el-button class="saveBtn" type="primary" @click="validateData">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '@/store'
import { returnItemBack } from '@/api/order'
import axios from 'axios'
export default {
  name: 'SendBack',
  components: {  },
  data() {
    return {     
      form: { 
        orderItemId:0,
        logistics:'',
        logisticsNo:'',
      },
      returnAddress:{},
      rules: { },  
      codeUrl:'',
      title: '',
      dialogFormVisible: false,
      loading:false,
      elementLoadingText:"数据提交中,请稍后...",            
    }
  },
  methods: {
    async showSendBack(order,orderItem) {  
      this.title = '寄回商品'     
      this.form.orderItemId = orderItem.id;   
      this.returnAddress = order.returnAddress;
      this.dialogFormVisible = true
    },     
    
    close() {    
      this.$refs['form'].resetFields()
      this.$emit('fetch-data')
      this.form = this.$options.data().form      
      this.dialogFormVisible = false
    },
    validateData()
    {
      if(this.form.orderItemId==null||this.form.orderItemId==0||this.form.orderItemId==undefined)
      {
        this.$message.error('未能找到回寄的子订单!')
        return
      }     
      if(this.form.logistics==null||this.form.logistics==''||this.form.logistics==undefined)
      {
        this.$message.error('回寄物流不可为空!')
        return 
      }  
      if(this.form.logisticsNo==null||this.form.logisticsNo==''||this.form.logisticsNo==undefined)
      {
        this.$message.error('回寄单号!')
        return 
      }  
      this.save();         
    },
    save() {    
      this.loading=true;
      this.elementLoadingText="数据提交中,请稍后..."
      var _this=this;
      this.$refs['form'].validate(async (valid) => {    
        if (valid) { 
          await returnItemBack(this.form).then(res=>{       
            _this.loading=false;   
            if(res&&res.data&&res.data.success==true)
            {
              _this.$confirm('操作成功，请静待商家处理！', '温馨提示',{type:'success'}).then(()=>
              {  
                 _this.$refs['form'].resetFields()
                 _this.$emit('fetch-data')
                 _this.dialogFormVisible = false     
                 _this.form = this.$options.data().form
              });   
            }    
            else
            {
               var msg='操作失败';
               if(res&&res.data&&res.data.error&&res.data.error.message)
               {
                  msg += ',原因:'+res.data.error.message;
               }
               this.$message({ message: msg, type: 'error', customClass: 'c-msg' })
            }
          })
        } else {
          _this.loading=false;
          return false
        }
      })
    },  
 
  },
}
</script>
<style>
.saveBtn
{
  background-color: #FF5E00 !important;
  border-color: #FF5E00 !important;
  color: #FFF !important;
  cursor: pointer !important;
}
.closeBtn
{
  border-color: #FF5E00 !important;
  color:#FF5E00 !important;
  cursor: pointer !important;
}
 .el-dialog__title
{
  font-size: 18px !important;
  color:#FF5E00 !important;
}


.refundReason
{
    width: 100%;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
}
.refundDescription
{
    width: 100%;
    height: 108px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    line-height: 1.5;
    outline: 0;
    padding: 3px 10px;
}

</style>


// WEBPACK FOOTER //
// SendBack.vue?a0f1438c